const liveRouter = () => {
    return [
        {
            // TODO.. 仅个性化专题会走到此路由，个性化专题没有做安全连接跳转，无法正常传参
            path: 'live/detail/:id/:classID/:resourceType',
            name: 'live',
            component: () => import(/* webpackChunkName: "live" */'../../modules/live/live-detail/index.vue')
        },
        {
            path: 'live/:type/:id/:code?',
            name: 'live',
            component: () => import(/* webpackChunkName: "live" */'../../modules/live/live-detail/index.vue')
        },
        {
            path: 'lives/keylogin/:id?',
            name: 'live',
            component: () => import(/* webpackChunkName: "live" */'../../modules/live/live-join/index.vue')
        }
    ];
};
export default liveRouter;
